import http from '../_http_v2';

const forgery = {
  //default
  list: (m) => { return http.post(`console/wmds/forgery/list`, m); },
  detail: (m) => { return http.get(`console/wmds/forgery/${m.id}`); },

  //crud
  insert: (m) => { return http.post(`console/wmds/forgery`, m); },
  update: (m) => { return http.put(`console/wmds/forgery`, m); },
  delete: (m) => { return http.delete(`console/wmds/forgery/${m.id}`); },
}

export default forgery

export { forgery }